'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducer;

var _reduxActions = require('redux-actions');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _IndexedAsyncData = require('conversations-async-data/indexed-async-data/IndexedAsyncData');

var _IndexedAsyncData2 = _interopRequireDefault(_IndexedAsyncData);

var _AsyncData = require('conversations-async-data/async-data/AsyncData');

var _AsyncData2 = _interopRequireDefault(_AsyncData);

var _updateEntries = require('conversations-async-data/indexed-async-data/operators/updateEntries');

var _requestStarted = require('conversations-async-data/async-data/operators/requestStarted');

var _requestSucceededWithOperator = require('conversations-async-data/async-data/operators/requestSucceededWithOperator');

var _requestFailed = require('conversations-async-data/async-data/operators/requestFailed');

var _resolvedAttachmentsActionTypes = require('../constants/resolvedAttachmentsActionTypes');

var _ActionTypes = require('../../thread-histories/constants/ActionTypes');

var _fileUploadsActionTypes = require('../../file-uploads/constants/fileUploadsActionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _IndexedAsyncData2.default)({
  notSetValue: (0, _AsyncData2.default)({ data: null })
});

var reducer = (_reducer = {}, _defineProperty(_reducer, _resolvedAttachmentsActionTypes.RESOLVE_ATTACHMENTS.STARTED, function (state, action) {
  var fileIds = action.payload.requestArgs.fileIds;


  return (0, _updateEntries.updateEntries)(fileIds, function (fileId, asyncData) {
    return (0, _requestStarted.requestStarted)(asyncData);
  }, state);
}), _defineProperty(_reducer, _resolvedAttachmentsActionTypes.RESOLVE_ATTACHMENTS.SUCCEEDED, function (state, action) {
  var _action$payload = action.payload,
      fileIds = _action$payload.requestArgs.fileIds,
      resolvedAttachments = _action$payload.data;


  return (0, _updateEntries.updateEntries)(fileIds, function (fileId, asyncData) {
    return (0, _requestSucceededWithOperator.requestSucceededWithOperator)(function () {
      var resolvedAttachment = (0, _get2.default)(fileId, resolvedAttachments);

      return resolvedAttachment;
    }, asyncData);
  }, state);
}), _defineProperty(_reducer, _ActionTypes.FETCH_THREAD_HISTORY.SUCCEEDED, function (state, action) {
  var resolvedAttachments = action.payload.data.files;


  var fileIds = resolvedAttachments.keySeq().toList();

  return (0, _updateEntries.updateEntries)(fileIds, function (fileId, asyncData) {
    return (0, _requestSucceededWithOperator.requestSucceededWithOperator)(function () {
      var resolvedAttachment = (0, _get2.default)(fileId, resolvedAttachments);

      return resolvedAttachment;
    }, asyncData);
  }, state);
}), _defineProperty(_reducer, _fileUploadsActionTypes.ASSOCIATE_ATTACHMENTS.SUCCEEDED, function (state, action) {
  var resolvedAttachments = action.payload.data;


  var fileIds = resolvedAttachments.keySeq().toList();

  return (0, _updateEntries.updateEntries)(fileIds, function (fileId, asyncData) {
    return (0, _requestSucceededWithOperator.requestSucceededWithOperator)(function () {
      var resolvedAttachment = (0, _get2.default)(fileId, resolvedAttachments);

      return resolvedAttachment;
    }, asyncData);
  }, state);
}), _defineProperty(_reducer, _resolvedAttachmentsActionTypes.RESOLVE_ATTACHMENTS.FAILED, function (state, action) {
  var fileIds = action.payload.requestArgs.fileIds;


  return (0, _updateEntries.updateEntries)(fileIds, function (fileId, asyncData) {
    return (0, _requestFailed.requestFailed)(asyncData);
  }, state);
}), _reducer);

exports.default = (0, _reduxActions.handleActions)(reducer, initialState);
module.exports = exports['default'];